<div class="no-results" [class.wrapper-margin]="isDetailPage" [class.incomplete-search-wrapper]="isFieldValidationError">
  <img
    class="subtract-img"
    src="assets/meta-search/meta-search-warning-sign.png"
  />
  <h3 class="font-medium error-message">
    {{errorMessage}}
  </h3>
</div>
 